export default {
  methods: {
    getItemTextColorClass(value, item, limit, nameColumn) {
      if (value == this.getMaxValue(item, limit, nameColumn) && value != 0)
        return 'text-success';
      if (value == this.getMinValue(item, limit, nameColumn))
        return 'text-danger';
      return '';
    },

    getMaxValue(item, limit, nameColumn) {
      return Math.max(...this.getColumnsName(item, limit, nameColumn));
    },

    getMinValue(item, limit, nameColumn) {
      return Math.min(...this.getColumnsName(item, limit, nameColumn));
    },

    getColumnsName(item, limit, nameColumn) {
      return Array.from(
        { length: limit },
        (_, i) => item[`${nameColumn}${i + 1}`]
      );
    },

    isNegative(number) {
      if (number < 0) {
        return 'text-danger';
      }
      return '';
    },
  },
};
